module.exports = __webpack_public_path__ + "img/word.be5da793.svg";